export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10278.9ab2ab1a.jpg";